import { InjectionToken } from '@angular/core';

export const SERVICE_TICKET_OVERLAY_IT = new InjectionToken('SERVICE_TICKET_OVERLAY_IT');
